import type { PersonId, RejectedTreeToTreeMatch } from '@fs/zion-tree-types'
import { useSwrRequest } from './useSwrRequest'

/**
 * Format for rejected tree-to-tree matches as returned by tree-data.
 * See: https://www.familysearch.org/service/tree/tree-data/match/persons/{personId}/rejected
 */
export type RejectedTreeToTreeMatchesResponse = {
  rejectedTreeToTreeMatches: RejectedTreeToTreeMatch[]
  recordNotAMatches: unknown[]
  notAMatchPersons: unknown[]
}

type UseRejectedPersonMatchesResult = {
  rejectedTreeToTreeMatches: RejectedTreeToTreeMatch[]
  loading: boolean
  refetch?: () => void
}

export default function useRejectedPersonMatches(personId?: PersonId): UseRejectedPersonMatchesResult {
  const { data, isLoading, mutate } = useSwrRequest<RejectedTreeToTreeMatchesResponse>(
    personId ? `/service/tree/tree-data/match/persons/${personId}/rejected` : null
  )

  return {
    rejectedTreeToTreeMatches: data?.rejectedTreeToTreeMatches ?? [],
    loading: !!isLoading,
    refetch: () => {
      mutate()
    },
  }
}
